import React from 'react'
import { useTranslation } from 'react-i18next';
import { 
	SidebarContainer,
	Icon,
	CloseIcon,
	SidebarWrapper,
	SidebarMenu,
	SidebarLink,
	SideBtnWrap,
	SidebarRoute
} from './SidebarElemets'

const Sidebar = ({isOpen, toggle}) => {
  const {t, i18n} = useTranslation();
  function handleClick(lang){
    window.location.reload(i18n.changeLanguage(lang))
  }
	return (
		<SidebarContainer isOpen ={isOpen} onClick={toggle}>
			<Icon onClick={toggle}>
				<CloseIcon />
			</Icon>
			<SidebarWrapper>
				<SidebarMenu>
					<SidebarLink to="/notice" onClick={toggle}>{t("issue")}</SidebarLink>
					<SidebarLink to="/console/faq" onClick={toggle}>FAQ</SidebarLink>
          <button className='sidebarBtn' onClick={()=> handleClick('en')}>English</button>
          <button className='sidebarBtn' onClick={()=> handleClick('ko')}>한국어</button>
				</SidebarMenu>
				<SideBtnWrap>
					<SidebarRoute href='https://console.shareplug.co.kr' style={{textDecoration:"none"}}>Login</SidebarRoute>
				</SideBtnWrap>
			</SidebarWrapper>
		</SidebarContainer>
	)
}

export default Sidebar
